unit GA.Web.Utils;

interface

uses WebLib.ExtCtrls;

type

TGAWebUtils = class
  class function RegulatorNumberValid(const ARegulator, ANumber: string): Boolean;
  class function EarliestClaimableDate(const ADate: TDate): TDate;
  class function EarliestClaimableDateStr(const ADate: TDate): string;
  class function EndofTaxYear(const ADate: TDate): TDate;
  class function StartOfTaxYear(const ADate: TDate): TDate;
end;

TDonationUIUtils = class
  const OTHER = 'Other';
  FOREIGN_DONATION = 'ForeignDonation';
  NONGIFTAIDABLE = 'NonGiftAidable';
  class procedure AddDonationClaimStatusLookupsToCombo(aComboItems: TLookupValues);
  class procedure AddDonationKindLookupsToCombo(aComboItems: TLookupValues);
  class procedure AddPaymentMethodLookupsToCombo(aComboItems: TLookupValues);
  class procedure AddDonorClaimStatusLookupsCombo(aComboItems: TLookupValues);
  class procedure AddDonorKindLookupsToCombo(aComboItems: TLookupValues);
  class procedure AddDonationClaimStatusNotEligibleForGiftAidLookupsToCombo(aComboItems: TLookupValues);
end;

TCountryUtils = class
  const UNKNOWN = 'Unspecified';
  const UNKNOWN_ALPHA2 = 'ZZ';
  class function GetCountryCodeFromCountryHelper(const aCountry: string): string;
  class function GetCountryFromCountryCodeHelper(const aCountryCode: string): string;
end;

implementation

uses System.SysUtils,
WebLib.RegularExpressions, System.DateUtils, WebLib.Country;

{ TGAWebUtils }

class function TGAWebUtils.RegulatorNumberValid(const ARegulator, ANumber: string): Boolean;
var lNumber: String;
begin
  lNumber := ANumber.Trim;
  Result := lNumber <> '';

  if not Result then
     Exit;

  { TODO : Check that the CharityId is a valid format TRegEx. }
end;


class function TGAWebUtils.EarliestClaimableDate(const ADate: TDate): TDate;
var
  lTaxYearEnd: TDate;
begin
  lTaxYearEnd := EndofTaxYear(ADate);
  Result := StartOfTaxYear(IncYear(lTaxYearEnd, -4));
end;

class function TGAWebUtils.EarliestClaimableDateStr(const ADate: TDate): string;
var
  lEarliestDate: TDate;
begin
  lEarliestDate := EarliestClaimableDate(ADate);
  result := FormatDateTime('DD/MM/YYYY', lEarliestDate);
end;

class function TGAWebUtils.EndofTaxYear(const ADate: TDate): TDate;
var
  lYear, lMonth, lDay: Word;
begin
  DecodeDate(ADate, lYear, lMonth, lDay);

  if (lMonth = 4) then
  begin
    if lDay > 5 then
      lYear := lYear + 1
  end
  else if lMonth > 4 then
  begin
    lYear := lYear + 1;
  end;

  Result := EncodeDate(lYear, 4, 5);
end;

class function TGAWebUtils.StartOfTaxYear(const ADate: TDate): TDate;
var
  lYear, lMonth, lDay: Word;
begin
  DecodeDate(ADate, lYear, lMonth, lDay);

  if (lMonth = 4) then
  begin
    if lDay < 6 then
      lYear := lYear - 1
  end
  else if lMonth < 4 then
  begin
    lYear := lYear - 1;
  end;

  Result := EncodeDate(lYear, 4, 6);
end;

{TDonationUIUtils}

class procedure TDonationUIUtils.AddDonationClaimStatusLookupsToCombo(aComboItems: TLookupValues);
begin
  aComboItems.Clear;
  aComboItems.AddPair('Unclaimed', 'Unclaimed');
  aComboItems.AddPair('NonGiftAidable', 'Non-Gift Aidable');
  aComboItems.AddPair('NGACustomerRequest', 'Non-Gift Aidable by Customer Request');
  aComboItems.AddPair('Unknown', 'Unknown');
end;

class procedure TDonationUIUtils.AddDonationClaimStatusNotEligibleForGiftAidLookupsToCombo(aComboItems: TLookupValues);
begin
  aComboItems.Clear;
  aComboItems.AddPair(NONGIFTAIDABLE, 'Non-Gift Aidable');
  aComboItems.AddPair('NGACustomerRequest', 'Non-Gift Aidable by Customer Request');
  aComboItems.AddPair('Unknown', 'Unknown');
end;

class procedure TDonationUIUtils.AddDonationKindLookupsToCombo(aComboItems: TLookupValues);
begin
  aComboItems.Clear;
  aComboItems.AddPair('Donation', 'Donation');
  aComboItems.AddPair('PayrollGiving', 'Payroll Giving');
  aComboItems.AddPair('Legacy', 'Legacy');
  aComboItems.AddPair(FOREIGN_DONATION, 'Foreign Donation');
  aComboItems.AddPair(OTHER, OTHER);
end;

class procedure TDonationUIUtils.AddPaymentMethodLookupsToCombo(aComboItems: TLookupValues);
begin
  aComboItems.Clear;
  aComboItems.AddPair('Cash', 'Cash');
  aComboItems.AddPair('Card', 'Card');
  aComboItems.AddPair('Cheque', 'Cheque');
  aComboItems.AddPair('StandingOrder', 'Standing Order');
  aComboItems.AddPair('DDR', 'DDR');
  aComboItems.AddPair('BankTransfer', 'Bank Transfer');
  aComboItems.AddPair('PayPal', 'PayPal');
  aComboItems.AddPair('WebCard', 'Web Card');
  aComboItems.AddPair(OTHER, OTHER);
end;

class procedure TDonationUIUtils.AddDonorClaimStatusLookupsCombo(aComboItems: TLookupValues);
begin
  aComboItems.AddPair('OK', 'OK');
  aComboItems.AddPair('AwaitingPaperwork', 'Awaiting Paperwork');
  aComboItems.AddPair('Deceased', 'Deceased');
  aComboItems.AddPair('Incomplete', 'Incomplete');
  aComboItems.AddPair('NoLongerPaysTax', 'No Longer Pays Tax');
  aComboItems.AddPair('NoValidAddressGiven', 'No Valid Address Given');
  aComboItems.AddPair('NoActiveGiftAid', 'No Active GiftAid');
  aComboItems.AddPair('RequestedRefund', 'Requested Refund');
  aComboItems.AddPair('Organisation', 'Organisation');
  aComboItems.AddPair('NonDomiciled', 'Non-domiciled');
  aComboItems.AddPair('Inactive', 'Inactive');
  aComboItems.AddPair(OTHER, OTHER);
end;

class procedure TDonationUIUtils.AddDonorKindLookupsToCombo(aComboItems: TLookupValues);
begin
  aComboItems.AddPair('Individual', 'Individual');
  aComboItems.AddPair('Company', 'Company');
  aComboItems.AddPair('Charity', 'Charity');
end;

{ TCountryUtils }

class function TCountryUtils.GetCountryCodeFromCountryHelper(const aCountry: string): string;
begin
  if aCountry = UNKNOWN then
    Result := UNKNOWN_ALPHA2
  else
    Result := GetCountryCode(aCountry);
end;

class function TCountryUtils.GetCountryFromCountryCodeHelper(const aCountryCode: string): string;
begin
  if aCountryCode = UNKNOWN_ALPHA2 then
    Result := UNKNOWN
  else
    Result := GetCountryByCode(aCountryCode);
end;

end.
